/**
 * Centralized route definitions for mobile views.
 * Prevents typos and provides a single source of truth for all mobile navigation paths.
 */
export const mobileRoutes = {
    dashboard: (domainId: string | number) => `/domains/${domainId}/dashboard`,

    dashboardDrafts: (domainId: string | number) => `/domains/${domainId}/dashboard?tab=drafts`,

    notificationNew: (domainId: string | number) => `/domains/${domainId}/notifications/new`,

    notificationDuplicate: (domainId: string | number, notificationId: string | number) =>
        `/domains/${domainId}/notifications/new?notification_id=${notificationId}`,

    notificationEdit: (domainId: string | number, notificationId: string | number) =>
        `/domains/${domainId}/notifications/edit/${notificationId}`,

    notificationSummary: (domainId: string | number, notificationId: string | number) =>
        `/domains/${domainId}/notifications/${notificationId}/summary`,

    insights: (domainId: string | number) => `/domains/${domainId}/insights`,
}
